export default function getQueryVariable(variable)
{
    const reg = new RegExp("\\b"+ variable +"=([^&]*)");
    const r = location.href.match(reg);
    if (r != null) return r[1];
}
